<template>
  <div
    class="app-layout"
    :class="[
      theme,
      { 'with-gap': gap, padding, 'extra-side-padding': extraSidePadding },
    ]"
    :style="{
      paddingBottom: footerPadding + 'px',
    }"
  >
    <AppLayoutHeader v-if="$slots.header">
      <slot name="header" />
    </AppLayoutHeader>

    <AppLayoutContent
      v-if="$slots.content ?? $slots.image"
      class="layout-content-wrapper"
    >
      <div v-if="$slots.image" class="image">
        <slot name="image" />
      </div>

      <div v-if="$slots.content" class="layout-content">
        <slot name="content" class="layout-content" />
      </div>
    </AppLayoutContent>

    <slot v-if="$slots.default" />

    <AppLayoutFooter
      v-if="$slots.footer"
      :fixed="fixedFooter"
      ref="footer"
      @resize="({ height }) => (footerPadding = height)"
    >
      <slot name="footer" />
    </AppLayoutFooter>
  </div>
</template>

<script>
import AppLayoutHeader from '@/components/App/Layout/Header'
import AppLayoutContent from '@/components/App/Layout/Content'
import AppLayoutFooter from '@/components/App/Layout/Footer'

export default {
  name: 'AppLayout',

  components: {
    AppLayoutHeader,
    AppLayoutContent,
    AppLayoutFooter,
  },

  data() {
    return {
      footerPadding: undefined,
    }
  },

  props: {
    theme: {
      type: String,
      required: false,
    },

    gap: {
      type: Boolean,
      default: false,
    },

    padding: {
      type: Boolean,
      default: false,
    },

    extraSidePadding: {
      type: Boolean,
      default: false,
    },

    fixedFooter: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.app-layout {
  $defaultPadding: 1.5rem;
  display: flex;
  flex: 1;
  flex-direction: column;
  max-width: 100vw;
  // min-height: 100vh;

  &.with-gap {
    gap: 1rem;
  }

  &.padding {
    padding: 1rem;
  }

  &.extra-side-padding {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  > .layout-content-wrapper {
    display: flex;
    flex: 1;

    > .layout-content {
      max-width: stretch;
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    @media (max-width: 480px) {
      flex-direction: column;
    }
  }
}
</style>
